
import './App.css';

import Header from '@Components/Header';

function App() {
  return (
    <div className="App">
      <Header />
      404
    </div>
  );
}

export default App;
